<template>
  <p :class="$b({ priceBelowTitle, size })">
    <span v-if="priceLocal === null">
      <!-- Don't show anything when the price is undefined -->
    </span>

    <span v-else-if="priceLocal === 0">
      Free
    </span>

    <template v-else>
      <span
        v-if="isMinimumPrice"
        data-testid="from-price-prefix"
      >
        {{ 'From ' }}
      </span>

      <span
        v-if="isDiscounted"
        :class="$b('discount')"
      >
        {{ $tcs(preDiscountPriceLocal) }}
      </span>

      <span>
        {{ $tca(Math.max(priceLocal, 0)) }}
      </span>
    </template>
  </p>
</template>

<script>
export default {
  name: 'ProductPrice',

  props: {
    preDiscountPrice: { type: Number, required: false, default: 0 },
    price: { type: [Number, Object], default: 0 },
    isMinimumPrice: { type: Boolean, default: false },

    size: {
      type: String,
      default: 'medium',
      validator: (val) => ['medium', 'small'].includes(val),
    },
    priceBelowTitle: { type: Boolean, default: false },
  },

  data: () => ({
    priceLocal: null,
    preDiscountPriceLocal: null,
  }),

  computed: {
    isDiscounted() {
      return this.priceLocal < this.preDiscountPriceLocal
    },
  },

  watch: {
    price: {
      handler() {
        this.updatePrices()
      },
      immediate: true,
    },
    preDiscountPrice: {
      handler() {
        this.updatePrices()
      },
      immediate: true,
    },
  },

  created() {
    this.priceLocal = this.price
    this.preDiscountPriceLocal = this.preDiscountPrice
  },

  methods: {
    updatePrices() {
      this.$nextTick(() => {
        this.priceLocal = this.price
        this.preDiscountPriceLocal = this.preDiscountPrice
      })
    },
  },
}
</script>

<style lang="postcss">
.ProductPrice {
  @apply whitespace-nowrap text-sm leading-tight tracking-tight font-normal text-black;
    md:text-base;

  &--price-below-title {
    @apply pl-0;
  }
}

.ProductPrice__discount {
  @apply text-xs opacity-40 uppercase line-through;
}

/**
  Modifiers
*/
.ProductPrice--size-small {
  @apply text-xs;
}
</style>
